import axios from 'axios';

// Cross-client (from_link) таб: клиентът е дошъл в менюто на друг клиент през
// линкова категория (?from_link=1). Табът разглежда И поръчва от новия обект, но
// кукито tabl_place, поръчковата сесия (_tot_) и количката на обекта, от който е
// дошъл, трябва да останат непокътнати (при връщане там всичко си е същото).
// Затова за таба пазим обекта, сесията и количката в sessionStorage, а сървърът
// взима обекта от header-а `place` (виж apiRoutes.js), не от кукито.
const FROM_LINK_FLAG_KEY = 'tabl_from_link';
const FROM_LINK_PLACE_KEY = 'tabl_from_link_place';
export const FROM_LINK_ORDER_TOKEN_KEY = 'tabl_from_link_tot';
export const FROM_LINK_HEADER = 'x-tabl-from-link';

// Ключовете за количката са същите като в localStorage/кукитата - сменя се само хранилището.
const CART_KEY = 'to_order';
const CART_ID_KEY = 'tabl_cart';

const session = () => {
    try {
        return window.sessionStorage;
    } catch (e) {
        return null;
    }
};

export const isFromLinkTab = () => {
    const s = session();
    return !!(s && s.getItem(FROM_LINK_FLAG_KEY) == '1');
};

export const setFromLinkTab = (on) => {
    const s = session();
    if (s) {
        if (on) {
            s.setItem(FROM_LINK_FLAG_KEY, '1');
        } else {
            s.removeItem(FROM_LINK_FLAG_KEY);
        }
    }

    if (on) {
        axios.defaults.headers.common[FROM_LINK_HEADER] = '1';
    } else {
        delete axios.defaults.headers.common[FROM_LINK_HEADER];
    }
};

export const getFromLinkPlace = () => {
    const s = session();
    return s ? s.getItem(FROM_LINK_PLACE_KEY) : null;
};

export const setFromLinkPlace = (placeId) => {
    const s = session();
    if (s) s.setItem(FROM_LINK_PLACE_KEY, placeId);
};

// Чисти обекта/сесията/количката на from_link таба (при връщане у дома или при
// преминаване към трети клиент - старата количка е с чужди продукти).
export const resetFromLinkSession = () => {
    const s = session();
    if (s) {
        [FROM_LINK_PLACE_KEY, FROM_LINK_ORDER_TOKEN_KEY, CART_KEY, CART_ID_KEY].forEach(k => s.removeItem(k));
    }
};

// Хранилище за количката: localStorage, а в from_link таб - sessionStorage.
export const cartStorage = () => (isFromLinkTab() && session()) || window.localStorage;
